import { testimonials, stats, faqs } from '@/mocks/about';

export default function About() {
  return (
    <main>
      <section className="w-full px-4 md:px-6 pt-24 pb-10 md:pb-14">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
            关于西瓜影视
          </h1>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
            西瓜影视成立于2020年，是一家专注于提供高品质在线观影体验的影视平台。我们致力于打造一个资源丰富、画质超清、播放流畅的影视内容聚合平台，让每一位用户都能享受到极致的观影体验。
          </p>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 text-center mb-8">
            品牌数据
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-background-50 rounded-xl p-5 md:p-6 text-center"
              >
                <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className={`${stat.icon} text-lg text-primary-600`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 text-center mb-2">
            用户口碑
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">
            来自真实用户的使用评价
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <div
                key={t.id}
                className="bg-background-100 rounded-xl p-5 md:p-6 flex flex-col"
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">
                      {t.name}
                    </div>
                    <div className="text-xs text-foreground-500">{t.date}</div>
                  </div>
                </div>
                <div className="flex items-center gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i
                        className={`text-sm ${
                          i < t.rating
                            ? 'ri-star-fill text-accent-400'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  "{t.content}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 text-center mb-8">
            常见问题
          </h2>
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer"
              >
                <summary className="flex items-center justify-between px-5 py-4 md:px-6 md:py-4 text-sm font-semibold text-foreground-800 list-none">
                  {faq.question}
                  <div className="w-5 h-5 flex items-center justify-center transition-transform duration-200 group-open:rotate-180">
                    <i className="ri-arrow-down-s-line text-foreground-400"></i>
                  </div>
                </summary>
                <div className="px-5 pb-4 md:px-6 md:pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-4">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 mb-8 leading-relaxed">
            如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们的客服团队将竭诚为您服务。
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-background-100 rounded-xl p-5">
              <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-800">service@xiguays.com</div>
            </div>
            <div className="bg-background-100 rounded-xl p-5">
              <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-lg text-accent-600"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">在线客服</div>
              <div className="text-sm font-medium text-foreground-800">7×24小时</div>
            </div>
            <div className="bg-background-100 rounded-xl p-5">
              <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-shake-hands-line text-lg text-secondary-600"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">商务合作</div>
              <div className="text-sm font-medium text-foreground-800">bd@xiguays.com</div>
            </div>
          </div>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于西瓜影视',
            description: '西瓜影视成立于2020年，专注于提供高品质在线观影体验的影视平台。',
            url: 'https://www.xiguays.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '西瓜影视',
              url: 'https://www.xiguays.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </main>
  );
}